@if (contentlet()) { @if (contentlet().url) {
<div class="video-container default-video-class youtube-video" [ngClass]="getVideoClasses(contentlet())">
  <div [ngClass]="(getVideoHeight$(contentlet()) | async) ? 'video-wrapper custom-video-wrapper' : 'video-wrapper'">
    <!-- spell-checker: words allowfullscreen -->
    @if (iframeVideoUrl(contentlet()); as url) {
    <iframe
      [ngStyle]="{ 'height.px': (getVideoHeight$(contentlet()) | async) }"
      [title]="contentlet()?.title"
      [src]="url"
      frameborder="0"
      allow="accelerometer; autoplay *; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    }
  </div>
</div>
} }
